<script>
import Vue from 'vue';
import moment from 'moment';

export default {
  name: 'RecebimentoDeNotaFiscalRejeitarItemModal',
  props: {
    value: Boolean,
    nfItens: Array
  },
  data() {
    return {
      isFormValid: false,
      itemOptions: [],
      tipoOperacaoOptions: [],
      localOptions: [],
      quantidadeMaxima: 0,
      modalOpen: false,
      user: {},
      rules: {
        required: v => !!v || "Campo obrigatório",
        min: v => v >= 0 || "Valor não pode ser negativo",
        max: v => v <= this.quantidadeMaxima || `Máximo permitido é ${this.quantidadeMaxima > 0 ? this.quantidadeMaxima : 0}`
      },
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val); // Emite evento para atualizar o estado do modal
      }
    },
    themeClass() {
      return this.$vuetify.theme.dark ? 'dark-theme' : 'light-theme';
    },
  },
  methods: {

    async console(item) {
      console.log(item)
    },

    async getTenanty() {
      const lc = window.localStorage.getItem("UsuarioStore");
      const user = JSON.parse(lc);

      const req = await Vue.prototype.$http.get(`/Entity/Collaborator/search-fields?value=${user.id}&companySiteId=userId`)
      this.user = req?.data?.data?.data?.[0]
    },

    async capitalizeSelectedKeys(obj) {
      const keysToCapitalize = [
        'nCM',
        'cFOP',
        'cOFINSValor',
        'cOFINSPerc',
        'cOFINSBaseCalculo',
        'pISValor',
        'pISPerc',
        'pISBaseCalculo',
        'iPIValor',
        'iPIPercIPI',
        'iPIBaseCalculo',
        'iCMSValor',
        'iCMSPercICMS',
        'iCMSBaseCalculo'
      ];

      const result = {};

      for (const key in obj) {
        if (
          Object.prototype.hasOwnProperty.call(obj, key) &&
          obj[key] !== null &&
          obj[key] !== undefined &&
          obj[key] !== 'Empty'
        ) {
          if (keysToCapitalize.includes(key)) {
            const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
            result[capitalizedKey] = obj[key];
          } else {
            result[key] = obj[key];
          }
        }
      }

      return result;
    },

    async deleteItem() {
      const payload = []
      for(const item of this.nfItens) {
        const {
          _id,
          updateAt,
          updateBy,
          deleteAt,
          deleteBy,
          isDeleted,
          createAt,
          createBy,
          pedidoDeCompra,
          operacaoFiscal,
          quantidade,
          local,
          osItem,
          item: nestedItem,
          ...rest
        } = item;

        const {
          updateAt: updateAtOs,
          updateBy: updateByOs,
          deleteAt: deleteAtOs,
          deleteBy: deleteByOs,
          isDeleted: isDeleteOs,
          _id: idOs,
          ...osRest
        } = osItem;

        await Vue.prototype.$http.put(`/Entity/OrdemDeServicoItens`, {
          ...osRest,
          id: idOs,
          status: 'GP' 
        });
        
        const formatted = await this.capitalizeSelectedKeys(rest);
      

        payload.push({
          ...formatted,
          id: _id,
          status: 'Recusado',

        });
      }

      await Vue.prototype.$http.put(`/Entity/updateMany/FisDocRecItem`, payload);

      Vue.prototype.$notify({
        title: "Item Recusado com Sucesso!",
        closeOnClick: true,
        duration: 3000,
        positions: "right",
        type: "success",
      });

      this.$emit('close')
    },

    resetPayload() {
      this.payload = this.getInitialPayload();
    },

    setModalOpen() {
      this.modalOpen = !this.modalOpen;
    },

  },
  watch: {
    value(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.resetValidation();
          }
        });
      }
    }
  },
  created() {
    this.getTenanty();
  }
};
</script>

<template>
  <v-dialog v-model="dialog" width="800" content-class="dialog-reject-item">
    <v-card style="overflow-x: scroll;">
      <v-list >
        <v-list-item style="display: flex; width: 100%; justify-content: end; padding: 20px 25px 0px 25px;" >
          <v-list-item-title style="font-size: 18px; font-weight: bold;">Recusar Itens</v-list-item-title>
          <v-btn 
            @click="$emit('close')"
            style="display: flex; background-color: transparent; justify-self: center; margin-right: 12px;"
          >
            Cancelar
          </v-btn>
          <v-btn 
            style="display: flex; background-color: blue; align-self: end; justify-self: end; margin-bottom: 6px; color: white !important;"
            @click="deleteItem"
          >
            Salvar <v-icon style="margin-left: 4px;">mdi-check</v-icon>
          </v-btn>
        </v-list-item>
      </v-list>
      <v-form ref="form" v-model="isFormValid">
        <v-list style="display: flex; padding: 12px; flex-direction: row; flex-wrap: wrap; gap: 18px;" v-for="(item, i) in nfItens" :key="i">
          <v-textarea
            v-model="item.reasoning"
            :label="item.description"
            dense
            outlined
            :rules="[rules.required]"
          ></v-textarea>
        </v-list>
      </v-form>
    </v-card>
  </v-dialog>
</template>
  
<style scoped>

    .style-i {
        color: white;
        font-size: 22px;
    }
    /*
    .style-i:hover {
        color: white;
    }*/

    .item-content {
        border-bottom: 1px solid rgba(172, 168, 168, 0.719);
    }

    a {
        color: black;
        margin-left: 5px;
        color: black;
    }


    span {
        float: right;
        font-size: 10px;
    }
    .card-item{
        position: relative;
    }

    .card-item:hover {
        cursor: pointer;
        background-color: whitesmoke;
    }

    .btn-aprovar, .btn-enviar-obs {
        background-color: green;
        border-radius: 15px;
        padding: 6px;
        color: white;
        font-size: 12px;
        margin: 0px 8px;
    }

    .btn-aprovar:hover, .btn-enviar-obs:hover {
        background-color: white;
        border: 1px solid green;
        color: green;
    }

    .btn-reprovar, .btn-cancelar-obs {
        background-color: red;
        border-radius: 15px;
        padding: 6px;
        color: white;
        font-size: 12px;
        margin: 0px 8px;
    }

    .btn-reprovar:hover, .btn-cancelar-obs:hover {
        background-color: white;
        border: 1px solid red;
        color: red;
    }

    .obs-container {
        margin-top: 3px;
        border: 1px solid #c5c0c0;
        padding: 5px;
    }

    .span-enviado {
        position: absolute;
        right: 15px;
        bottom: 2px;
    }

    .v-list-item__content{
        padding: 0px;
        max-height: 75px;
    }

  .img {
    margin: auto;
  }
  
  .card {
    margin-left: 500px;
  }
  
  .v-btn {
    margin-top: 15px;
  }
  
  .dialog-sobre {
    width: 500px !important;
  }
  
  .v-dialog__content {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1), z-index 1ms;
    width: 100%;
    z-index: 6;
    outline: none;
  }

  .checkbox {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  
  .v-text-field--outlined fieldset {
    border: 0;
    border-bottom: 1px solid black;
    border-radius: 0;;
  }

  .v-text-field--outlined .v-text-field__slot {
    align-items: end !important;
  }

  .v-text-field .v-input__slot {
    padding: 0 !important;
  }

  .filterInputDate {
    outline: none;
    border: 1px solid #666;
    border-radius: 4px;
    width: 269px;
    padding-left: 10px;
    font-size: 12px;
    height: 40px;
  }

  .filterInput {
    width: 30%;
    text-decoration: none !important;
    border: none !important;
  }

  .theme--dark.v-list {
    background-color: #1e1e1e;
  }

  .v-sheet.v-stepper {
    border-radius: 0px;
  }

  .theme--dark.v-card {
    background-color: #1e1e1e;
  }

  .v-data-table-header {
    border-radius: 12px;
  }

  .v-btn[data-v-4b1b6f7c] {
    margin-top: 0px;
  }
  
  .v-stepper__header {
    box-shadow: none !important;
  }

  .v-stepper__content {
    padding: 0px 24px 16px 24px;
  }

  .theme--dark.tabsBg{
    background-color: #1e1e1e !important;
  }

  .checkbox-label ::v-deep(.v-label) {
    font-size: 16px; /* Aumente o tamanho conforme necessário */
    /* font-weight: bold; Opcional: deixa a fonte mais destacada */
  }
</style>
  